import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { findField } from '../../../../../../Resource/FormTemplates/Types';
import { T } from '../../../../../../Translations';
import ModalStore from '../../../../../Modal/Store';
import LearningCollectionEditStore from '../../../Edit/Store';
import { CustomizeState } from '../../../Edit/Store/Types';
import AddOns from '../AddOns';

interface Props {
  store: LearningCollectionEditStore;
  state: CustomizeState;
  execonlineCatalogModalStore: ModalStore;
  videoProjectFeedbackModalStore: ModalStore;
  warnUser: () => boolean;
}

const LearningCollectionDetails: React.FC<Props> = ({
  store,
  state,
  warnUser,
  execonlineCatalogModalStore,
  videoProjectFeedbackModalStore,
}) => {
  return (
    <div>
      <h3 className="mb-6 text-3xl font-semibold">
        {store.template
          .andThen((template) => findField('name', 'string', template.fields))
          .andThen((field) => fromEmpty(field.value))
          .map((name) => <T kind="Customize {{name}}" name={name} />)
          .getOrElse(() => (
            <T kind="Describe your collection" />
          ))}
      </h3>
      <div className="lg:flex lg:justify-between mb-6">
        <AddOns
          store={store}
          state={state}
          warnUser={warnUser}
          videoProjectFeedbackModalStore={videoProjectFeedbackModalStore}
          execonlineCatalogModalStore={execonlineCatalogModalStore}
        />
      </div>
    </div>
  );
};

export default observer(LearningCollectionDetails);
